import { type GetStaticPaths, type GetStaticProps } from 'next';
import ArticleCategoryPage, {
  getCategoryPageStaticProps,
} from '../../../../pageHelpers/articles/categoryPage';
import { getPlaiceholder } from 'plaiceholder';
import convertImageUrlToS3ImageUrl from '../../../../helpers/convertImageUrlToS3ImageUrl';
import getGameSlugs from '../../../../helpers/getGameSlugs';
import getArticleCategories from '../../../../helpers/getArticleCategories';

export const ArticleCategoryPagePath =
  '/[gameSlug]/articles/[articleCategorySlug]';

export default ArticleCategoryPage;

export const getStaticPaths: GetStaticPaths = async () => {
  const gameSlugs = await getGameSlugs();
  const articleCategorySlugs = (await getArticleCategories()).map(
    (x) => x.slug,
  );

  return {
    paths: gameSlugs.flatMap((gameSlug) =>
      articleCategorySlugs.map((articleCategorySlug) => ({
        params: {
          gameSlug,
          articleCategorySlug,
        },
      })),
    ),
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = getCategoryPageStaticProps(
  async (src: string) =>
    await getPlaiceholder(convertImageUrlToS3ImageUrl(src)),
);
